<template>
  <modal
    :active="active"
    @closed="$emit('closed', true)"
  >
    <h1 class="title is-4">Opret kopi af varen</h1>
    <p>Vælg de oplysninger der skal kopieres med over på den nye vare.</p>
    <div class="is-flex flex-col gap-2">
      <b-switch
      v-for="(value, key) in form"
      :key="key"
      v-model="form[key]"
      :rounded="false"
      class="users-change__toggle"
    >
      {{ labels[key] }}
    </b-switch>
    </div>
    
    <template v-slot:footer>
      <div class="footer-spacer">
        <button class="button is-primary" @click="makeCopy">Opret kopi</button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@elems/modal'

export default {
  components: {
    Modal,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {},
      labels: {
        masterData: 'Stamdata',
        descriptions: 'Beskrivelser',
        images: 'Billeder',
        terms: 'Egenskaber',
        prices: 'Priser',
        documents: 'Dokumenter',
        locations: 'Lagerstatus på lokationer',
      },
    }
  },
  mounted() {
    this.reset();
  },
  watch: {
    active() {
      if (!this.active) {
        this.reset();
      }
    }
  },
  methods: {
    reset() {
      this.form = {
        masterData: true,
        descriptions: true,
        images: true,
        terms: true,
        prices: true,
        documents: true,
        locations: true,
      };
      this.error = [];
    }, 
    makeCopy() {
      window.axios.post('/api/items/' + this.item.id + '/copy', this.form)
        .then(({ data }) => {
          this.$store.dispatch('setSuccess', 'Der blev oprettet en kopi af varen')

          this.$router.push({
            name: 'items',
            params: {
              id: data.id
            },
          });
        })
        .catch((error) => {
            console.error(error);
            this.$store.dispatch('setError', 'Der kunne ikke oprettes en kopi')
        })
    }
  }
}
</script>